import { DropAreaType, DropPointTarget } from "./types";
import WomanImage from "../assets/images/woman.png";

import CarotidArtery from "../assets/images/carotid_artery.png";
import Clavicle from "../assets/images/clavicle.png";
import DepressorAnguliOris from "../assets/images/depressor_anguli_oris.png";
import DepressorLabiiInferior from "../assets/images/depressor_labii_inferior.png";
import ExternalJugularVein from "../assets/images/external_jugular_vein.png";
import HyoidBone from "../assets/images/hyoid_bone.png";
import LevatorAnguliOris from "../assets/images/levator_anguli_oris.png";
import LevatorLabiiSuperioris from "../assets/images/levator_labii_superioris.png";
import Mentalis from "../assets/images/mentalis.png";
import OmohyoidMuscle from "../assets/images/omohyoid_muscle.png";
import OrbicularisOris from "../assets/images/orbicularis_oris.png";
import PectoralisMajorMuscle from "../assets/images/pectoralis_major_muscle.png";
import Platysma from "../assets/images/platysma.png";
import Risorius from "../assets/images/risorius.png";
import Sternocleidomastoid from "../assets/images/sternocleidomastoid.png";
import Sternohyoid from "../assets/images/sternohyoid.png";
import SublingualGland from "../assets/images/sublingual_gland.png";
import SubmandibularGland from "../assets/images/submandibular_gland.png";
import ThyroidCartilage from "../assets/images/thyroid_cartilage.png";
import ThyroidGland from "../assets/images/thyroid_gland.png";
import ZygomaticusMajor from "../assets/images/zygomaticus_major.png";



import { createContext, useContext } from "react";

export const DropsArea: DropAreaType[] = [
  {
    key: "1",
    points: [
      {
        key: "1",
        correctAnswer: "1",
        top: "63%",
        left: "51%",
      },
      {
        key: "2",
        correctAnswer: "3",
        top: "34%",
        left: "60%",
      },
      {
        key: "3",
        correctAnswer: "4",
        top: "30%",
        left: "65%",
      },
      {
        key: "4",
        correctAnswer: "5",
        top: "52%",
        left: "51%",
      },
      {
        key: "5",
        correctAnswer: "6",
        top: "51.5%",
        left: "61%",
      },
      {
        key: "6",
        correctAnswer: "7",
        top: "24%",
        left: "58%",
      },
      {
        key: "7",
        correctAnswer: "8",
        top: "18%",
        left: "61%",
      },
      {
        key: "8",
        correctAnswer: "9",
        top: "34%",
        left: "70%",
      },
      {
        key: "9",
        correctAnswer: "10",
        top: "60%",
        left: "56%",
      },
      {
        key: "10",
        correctAnswer: "11",
        top: "26%",
        left: "70%",
      },
      {
        key: "11",
        correctAnswer: "11",
        top: "18%",
        left: "67%",
      },
      {
        key: "12",
        correctAnswer: "15",
        top: "82%",
        left: "56%",
      },
      {
        key: "13",
        correctAnswer: "16",
        top: "73%",
        left: "58%",
      },
      {
        key: "14",
        correctAnswer: "18",
        top: "44%",
        left: "61%",
      },
      {
        key: "15",
        correctAnswer: "19",
        top: "65%",
        left: "62%",
      },
      {
        key: "16",
        correctAnswer: "21",
        top: "20%",
        left: "51%",
      },
      {
        key: "17",
        correctAnswer: "13",
        top: "81%",
        left: "44%",
      }
    ],
    draggingArea: {
      headerText: "Drag and Drop the right choice on Omohyoid muscle",
      titleSrc: "",
      options: [
        { key: "1", value: "1", imageSrc: CarotidArtery },
        { key: "2", value: "2", imageSrc: Clavicle },
        { key: "3", value: "3", imageSrc: DepressorAnguliOris },
        { key: "4", value: "4", imageSrc: DepressorLabiiInferior },
        { key: "5", value: "5", imageSrc: ExternalJugularVein },
        { key: "6", value: "6", imageSrc: HyoidBone },
        { key: "7", value: "7", imageSrc: LevatorAnguliOris },
        { key: "8", value: "8", imageSrc: LevatorLabiiSuperioris },
        { key: "9", value: "9", imageSrc: Mentalis },
        { key: "10", value: "10", imageSrc: OmohyoidMuscle },
        { key: "11", value: "11", imageSrc: OrbicularisOris },
        { key: "12", value: "12", imageSrc: PectoralisMajorMuscle },
        { key: "13", value: "13", imageSrc: Platysma },
        { key: "14", value: "14", imageSrc: Risorius },
        { key: "15", value: "15", imageSrc: Sternocleidomastoid },
        { key: "16", value: "16", imageSrc: Sternohyoid },
        { key: "17", value: "17", imageSrc: SublingualGland },
        { key: "18", value: "18", imageSrc: SubmandibularGland },
        { key: "19", value: "19", imageSrc: ThyroidCartilage },
        { key: "20", value: "20", imageSrc: ThyroidGland },
        { key: "21", value: "21", imageSrc: ZygomaticusMajor }
      ]
    },
    initialImage: WomanImage,
    targetImage: WomanImage,
    successCount: 16

  }
];

export type State = {
  gameTarget: number;
  gameChecked: number;
  score: number;
  code?: string;
  name: string;
  dispatch: any;
};

export const ACTIONS = {
  INCREAMEANT_SCORE: "INCREAMEANT_SCORE",
  DECREAMEANT_SCORE: "DECREAMEANT_SCORE",
  INCREAMEANT_CHECKED: "INCREAMEANT_CHECKED",
  SET_USER_DATA: "SET_USER_DATA",
  RESET: "RESET",
};

export const initialState: State = {
  // gameTarget: DropsArea.map((area: DropAreaType) =>
  //   area.points.reduce((a, b) => a + b.target, 0)
  // ).reduce((a, b) => a + b, 0),
  gameTarget: 10,
  gameChecked: 0,
  score: 0,
  dispatch: undefined,
  name: "",
  code: undefined,
};

export const reducer = (
  state: State,
  action: { type: string; payload?: any }
) => {
  switch (action.type) {
    case ACTIONS.INCREAMEANT_SCORE:
      return { ...state, score: state.score + (action?.payload || 0) };
    case ACTIONS.DECREAMEANT_SCORE:
      return { ...state, score: state.score - (action?.payload || 0) };
    case ACTIONS.INCREAMEANT_CHECKED:
      return {
        ...state,
        gameChecked: state.gameChecked + (action?.payload || 0),
      };
    case ACTIONS.SET_USER_DATA:
      return {
        ...state,
        name: action.payload.name,
        code: action.payload.code,
      };

    case ACTIONS.RESET:
      return initialState;
    default:
      return state;
  }
};

export const ScoreContext = createContext(initialState);
export const useScore = () => useContext(ScoreContext);

export const TOTAL_TIME = 60 * 60; // seconds
